import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const ContactSection = () => {
  const { owner, phone, whatsapp, address } = contactInfo;

  return (
    <section id="contact" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Visit Our <span className="text-accent">Store</span>
          </h2>
          <p className="text-xl text-gray-600">
            Come visit us at our Jabalpur location
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-6">Contact Information</h3>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin size={24} className="text-accent" />
                  </div>
                  <div>
                    <p className="font-semibold mb-1 text-white">Address</p>
                    <p className="text-gray-300 leading-relaxed">
                      {address.line1}<br />
                      {address.line2}<br />
                      {address.line3}<br />
                      {address.state} - {address.pincode}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone size={24} className="text-accent" />
                  </div>
                  <div>
                    <p className="font-semibold mb-1 text-white">Phone</p>
                    <a href={`tel:919713889720`} className="text-gray-300 hover:text-accent transition-colors block">
                      +91 9713889720 (Call / WhatsApp)
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock size={24} className="text-accent" />
                  </div>
                  <div>
                    <p className="font-semibold mb-1 text-white">Business Hours</p>
                    <p className="text-gray-300 leading-relaxed">
                      Monday: 11:00 AM - 9:00 PM<br />
                      <span className="text-accent font-semibold">Tuesday: Closed</span><br />
                      Wednesday: 11:00 AM - 9:00 PM<br />
                      Thursday: 11:00 AM - 9:00 PM<br />
                      Friday: 11:00 AM - 9:00 PM<br />
                      Saturday: 11:00 AM - 9:00 PM<br />
                      Sunday: 11:00 AM - 9:00 PM<br />
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-700">
                <p className="font-semibold mb-2 text-white">Owner</p>
                <p className="text-xl text-accent">{owner}</p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="bg-gray-50 rounded-xl p-6">
              <h4 className="font-semibold text-gray-900 mb-4">Quick Actions</h4>
              <div className="space-y-3">
                <a
                  href={`tel:919713889720`}
                  className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-primary hover:shadow-md transition-all"
                >
                  <div className="flex items-center gap-3">
                    <Phone className="text-primary" size={20} />
                    <span className="font-medium text-gray-900">Call Now</span>
                  </div>
                </a>
                <a
                  href={`https://wa.me/919713889720?text=${encodeURIComponent('Hello, I want fabric information')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-primary hover:shadow-md transition-all"
                >
                  <div className="flex items-center gap-3">
                    <Phone className="text-primary" size={20} />
                    <span className="font-medium text-gray-900">WhatsApp Us</span>
                  </div>
                </a>
                <a
                  href={`https://maps.google.com/?q=23.1744563,79.9283883`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block p-4 bg-white rounded-lg border border-gray-200 hover:border-primary hover:shadow-md transition-all"
                >
                  <div className="flex items-center gap-3">
                    <MapPin className="text-primary" size={20} />
                    <span className="font-medium text-gray-900">Get Directions</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div className="h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.123!2d79.9283883!3d23.1744563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981af98c4391d95%3A0xc4d71c1da3d62510!2sArihant%20Sales%20Dj!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="ARIHANT SALES Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
